import { EmptyStateProps } from '@lyearn/molecules';
import { FilterState } from '@/components/FilterManager/types';
import type { IconType } from '@/utils/icon';

export interface SearchListEmptyStateProps {
  className?: string;
  title?: string | null;
  description?: EmptyStateProps['description'];
  size?: EmptyStateProps['size'];
  filter?: FilterState;
  search?: string;
  clearSearch?: () => void;
  clearFilters?: () => void;
  Icon?: IconType;
  width?: EmptyStateProps['width'];
  action?: { label: string; onClick: () => void };
  doNotUseFooter?: React.ReactNode;
  ignoreKeys?: string[];
}

export type SearchListEmptyStateLabelType = Pick<
  SearchListEmptyStateProps,
  'title' | 'description' | 'Icon' | 'className' | 'action' | 'width'
>;

export enum SearchListEmptyStateType {
  Filter = 'FILTER',
  Search = 'SEARCH',
  Content = 'CONTENT',
}
